<template>
<div  :key="k" class="mt-2 text-body-2">
    <p  v-if="keepStatusSubmitted" :class="['text-h6',textcolor(publication.asep)]">ASEP
        <span v-if="publication.asep == 2">registered</span>
        <span v-else-if="publication.asep == 1">submitted</span>
        <span v-else-if="publication.asep ==0">empty</span>
        <span v-else>register directly</span>
    </p>
    <p v-else class="text-h6 red--text">ASEP registered</p>
    <p><span class="font-weight-bold">URL:</span> {{ publication.url }}</p>
    <p v-if="asepdata.id"><span class="font-weight-bold">Language: </span>{{ getLanguage(asepdata.language) }}</p>
    <p class="font-weight-bold pa-0 ma-0">Annotation in English:</p>
    <p v-html="asepdata.annotation_eng"></p>
    <p v-if="asepdata.language > 1" class="font-weight-bold pa-0 ma-0">Annotation in <span class="text-capitalize">{{ getLanguage(asepdata.language)}}</span>:</p>
    <p v-html="asepdata.annotation_orig"></p>
    <p ><span class="font-weight-bold">Key words:</span> <span v-html="asepdata.keywords" ></span></p>
    <p v-if="asepdata.grants_extern"><span class="font-weight-bold">External grants: </span>{{ asepdata.grants_extern }}</p>
    <!-- Externals authors with country -->
    <p class="font-weight-bold pb-0 mb-0">Country of external authors :</p>
    <div v-for="(author,index) in publication.authors" :key="index" class="pa-0 ma-0">
        <p  v-if="author.type == 0" class="pa-0 ma-0">
            <span v-html="author.name_last+' '+author.name_first" class="pa-0" ></span>
            <span v-if="author.country_id &&  author.country_id < 100" class="font-weight-bold px-1 py-0">country:</span>{{ getCountry(author.country_id) }}
        </p>
    </div>
    <p  v-if="publication.type > 1" class="pt-1">
        <span class="font-weight-bold pr-1">ISBN </span> {{ asepdata.isbn }}
        <span class="font-weight-bold px-1">number of pages:</span>{{ asepdata.nb_pages }}
    </p>
    <p  v-if="namePath == 'asep.status.bo'" class="pt-2">
         <v-btn v-if="publication.asep == 1 && keepStatusSubmitted" color="red"  x-small @click="registerAsep(2)">
            Asep registered
        </v-btn>
        <v-btn outlined x-small @click="sendEmailAsep">Email to authors</v-btn>
    </p>

</div>
</template>
<script>
import router from '../../../../../router';
import {mapGetters} from 'vuex';

export default {
    props:['publication'],
    data(){
        return {
            countries:[],
            languages:[],
            asepdata:{
                id:null,
                annotation_eng:' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
                general_id:this.publication.id,
                keywords:'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
                language:0,
            },
            k:0,
            keepStatusSubmitted:true,
        }
    },
    created(){
        this.allDataLoaders = Promise.all([
                this.getCountriesLanguages(),
                this.getAsepData(),
                this.asepdata,
            ]);
        // signalDataUpdate will await the promise before doing anything.
        this.signalDataUpdate();

    },
    computed:{
        ...mapGetters('formpublication',{
            namePath:'namePath',
            }),
    },
    methods:{
        getLanguage(lang){
            var nameLanguage = '';
            this.languages.forEach(language => {
                if(language.id == lang){
                    nameLanguage = language.name;
                }
            });
            return nameLanguage;

        },
        getCountry(id){
            if(this.countries[id-1]){
                return this.countries[id-1].name;
            }
            else{
                return '';
            }
        },
        async getCountriesLanguages(){
            var path = '/index.php/api/bo/research/publications/asep/countries';
            try{
                const res = await axios.get(path);
                if(res){
                        this.countries =  res.data[0];
                        this.languages =  res.data[1];
                    }
            } catch (error) {
                throw error;
            }
        },
        async getAsepData(){
            var path = '/index.php/api/bo/research/publications/asep/data/'+this.publication.id+'/'+this.publication.type;
            try{
                const res = await axios.get(path);
                if(res){
                        this.asepdata =  res.data;
                }
            } catch (error) {
                throw error;
            }
        },
        async signalDataUpdate() {
            // Make sure all the needed data has been retrieved.
            await this.allDataLoaders;
            this.k++;
        },
        textcolor(asep){
            if(asep == 2){
                return 'red--text'
            }
            else if(asep == 3){
                return 'grey--text'
            }
            else if(asep == 1){
                return 'green--text'
            }
            else{
                return 'black--text';
            }
        },
        async registerAsep(status){
            var path = '/index.php/api/bo/research/publications/asep/status/'+this.publication.id+'/'+status;
            try{
                const res = await axios.post(path);
                if(res){
                    this.keepStatusSubmitted = false;
                    router.push({ name:'publication.repository',params:{id:this.publication.id,type:this.publication.type}});
                }
            } catch (error) {
                throw error;
            }
        },
        sendEmailAsep(){
            router.push({ name:'asep.email.data',params:{id:this.publication.id,type:this.publication.type}});
        },
        editAsepData(){
            router.push({ name:'asep.form',params:{asep:this.asep,type:this.publication.type,id:this.publication.id}});
        }

    }
}
</script>

